import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import AnnualTradesReportTable from "./AnnualTradesReportTable";
import { usePageStyles } from "../../pageStyles";
import { PageComponent } from "../../../core/navigation/types";
import { PageTitle } from "../../components/common/PageTitle";
import { DownloadButton, DownloadExcelButton } from "./DownloadButton";
import { ATRFilterButton } from "./ATRFilter";

const AnnualTradesReport: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={<PageTitle title="annualTradeReportTitle" />}
              action={<AnnualActions />}
            />
            <Divider />
            <CardContent>
              <AnnualTradesReportTable userAccessRights={userAccessRights} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const AnnualActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <ATRFilterButton />
    </Grid>
    <Grid item>
      <DownloadButton />
    </Grid>
    <Grid item>
      <DownloadExcelButton />
    </Grid>
  </Grid>
);

export default AnnualTradesReport;
